import { render, staticRenderFns } from "./Diameter-Report.vue?vue&type=template&id=dd18cafc&"
import script from "./Diameter-Report.vue?vue&type=script&lang=js&"
export * from "./Diameter-Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports